import React, { useState } from "react";
import axios from "axios";

const PrayerForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        request: "",
        honeypot: "", // Honeypot field
    });
    const [message, setMessage] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // If honeypot field is filled, ignore the submission
        if (formData.honeypot) {
            console.warn("Spam detected. Ignoring submission.");
            return;
        }

        try {
            const response = await axios.post("/api/googleSheets/submit-prayer", formData);
            setMessage({ type: "success", text: response.data.message });
            setFormData({ name: "", email: "", phone: "", request: "", honeypot: "" }); // Clear the form
        } catch (error) {
            console.error("Error submitting prayer request:", error);
            setMessage({ type: "error", text: "Failed to submit prayer request. Please try again." });
        }
    };

    return (
        <div className="prayer-form">
            {message && (
                <div
                    className={`alert ${
                        message.type === "success" ? "bg-green-100" : "bg-red-100"
                    } p-4 my-4`}
                >
                    {message.text}
                </div>
            )}
            <form onSubmit={handleSubmit}>
                {/* Honeypot Field */}
                <div style={{ display: "none" }}>
                    <label>Honeypot:</label>
                    <input
                        type="text"
                        name="honeypot"
                        value={formData.honeypot}
                        onChange={handleChange}
                        autoComplete="off"
                    />
                </div>
                <div>
                    <label>Name:</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="block w-full border rounded-lg p-2 my-2"
                    />
                </div>
                <div>
                    <label>Email:</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="block w-full border rounded-lg p-2 my-2"
                    />
                </div>
                <div>
                    <label>Phone:</label>
                    <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="block w-full border rounded-lg p-2 my-2"
                    />
                </div>
                <div>
                    <label>Request:</label>
                    <textarea
                        name="request"
                        value={formData.request}
                        onChange={handleChange}
                        required
                        className="block w-full border rounded-lg p-2 my-2"
                    />
                </div>
                <button
                    type="submit"
                    className="bg-red-700 text-white px-4 py-2 rounded-lg hover:bg-red-800"
                >
                    Submit Request
                </button>
            </form>
        </div>
    );
};

export default PrayerForm;
